export default __webpack_public_path__ + "src/assets/icn-add-assets.282ae72b34330a1801cadaea0c52f7bb.svg";